import { useUserContext } from 'UserContext';

export function useBlockedCounty() {
    const { user } = useUserContext();
    const effectiveDates = (user?.businesses_active ?? [])
        .map((b) => b.blocked_county_effective_date)
        .filter((d): d is string => Boolean(d))
        .sort();
    const effectiveDate = effectiveDates[0];
    return { isInBlockedCounty: Boolean(effectiveDate), effectiveDate };
}
